import React, { useState } from "react";

import { navItems, OurKnowledge } from "../../constants";
import { useSelector, useDispatch } from "react-redux";
import { useStateContext } from "../../context/ContextProvider";
import { Link } from "react-router-dom";
import styles from "../../style";
import { LogoutUser } from "../../redux/actions/user";
import { CiLogin, CiLogout } from "../utils/icons";
function Navmobile({ active, DropActive }) {
  const [dropActiveMenu, setDropActiveMenu] = useState(false);
  const dispatch = useDispatch();
  const { user, isAuth ,isAdmin } = useSelector((state) => state.Users);
  const { currentDir } = useStateContext();

  return (
    <div className="  fixed rtl:left-5 ltr:right-5 top-16  w-[80%] p-5 rounded-lg border border-gray-200 dark:border-gray-900  bg-gradient-to-b from-color-5 to-color-6    dark:bg-gradient-to-b dark:from-color-9 dark:to-color-10 z-50 dark:bg-opacity-60 backdrop-blur-2xl border-color-5 ">
      <div className=" justify-between py-8 px-5 ">
        {navItems &&
          navItems.map((item, index) => (
            <Link
              to={item.link}
              onClick={() => {
                window.scrollTo(0, 0);
              }}
              key={index}
            >
            
                <div
                  className={`${
                    active === index + 1
                      ? "text-color-1 dark:text-white"
                      : " text-color-2  dark:hover:bg-gray-200"
                  }
                     flex items-center px-8 w-full h7 mb-3 justify-center  ${
                       styles.glass
                     } rounded-md bg-opacity-40 hover:bg-color-8   dark:text-gray-200 dark:hover:bg-gray-200 
                 flex items-center p-2   justify-between`}
                >
                  <span>
                    {" "}
                    {currentDir === "ltr" ? item.titleEn : item.titleAr}
                  </span>
                  {item.icon}
                </div>
         
            </Link>
          ))}
  
                  
                 
                  
                
   
      </div>
    </div>
  );
}

export default Navmobile;
